import { useEffect } from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import { useTranslator } from '@front-activerse/common-components';
import { useNavigate } from 'react-router-dom';
import { saveTimestamp } from '@front-activerse/common-components';
import { withMobileAppMode } from '@front-activerse/common-components';
import { useAppContext } from '@front-activerse/common-components';

export const TitleBar = ({ mobileAppMode, children, showBackBtn = true, level = 0 }) => {
  const { t } = useTranslator();
  const navigate = useNavigate();

  const {
    images: { backIcon },
    consts: { SLIDE_ROUTES_DURATION },
  } = useAppContext();

  useEffect(() => {
    window.onpopstate = () => {
      saveTimestamp(level, SLIDE_ROUTES_DURATION);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [level]);

  if (!mobileAppMode) {
    return (
      <div className="top-bar border-bottom">
        <Container>
          <Row>
            <Col xl={{ size: 10, offset: 1 }} className="px-3 px-xl-0 d-flex align-items-center">
              {showBackBtn && (
                <Button
                  color="link"
                  className="me-4 px-0 py-0 float-start back-btn"
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  <img src={backIcon} className="me-1" alt={t('back.button')} />
                  <span className="d-none d-md-inline">{t('back.button')}</span>
                </Button>
              )}
              <h1 className="title-small semi-bold mb-0 text-center w-100">
                <Container>
                  <Row>
                    <Col xl={{ size: 10, offset: 1 }} className="position-relative">
                      {children}
                    </Col>
                  </Row>
                </Container>
              </h1>
              <div className="clearfix" />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }

  return null;
};

export default withMobileAppMode(TitleBar);
